import React from 'react';
import { useState, useEffect } from 'react';
import './ColorMenu.scss';

export default function ColorMenu(props) {
    const [opacity, setOpacity] = useState(0);
    const [opacityVal, setOpacityVal] = useState('0%');


    const handlerSetColor = (color='#fff') => {
        if (props.selectedShapes && props.selectedShapes.length > 1) {
            if (props.isStrokeColor) {
                props.selectedShapes.forEach(shape => {
                    return shape.attr({'stroke': color});
                })
            } else {
                props.selectedShapes.forEach(shape => {
                    return shape.fill(color);
                });
            }
        } else {
            if (props.selectedShape) {
                if (props.isStrokeColor) {
                    props.selectedShape.attr({'stroke': color});
                } else {
                    props.selectedShape.fill(color);
                }
            }
        }

        props.updateIconColor(color);
    }

    const handleShapeOpacityRange = (e) => {
        setOpacity(e.target.value);
        setOpacityVal(e.target.value + '%');

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({ 'fill-opacity': e.target.value / 100 });
            });
        }

        if (props.selectedShape) {
            props.selectedShape.attr({ 'fill-opacity': e.target.value / 100 });
        }
    }

    useEffect(() => {
        if (props.selectedShapes && props.selectedShapes.length > 1) {
            setOpacity(props.selectedShapes[0].attr('fill-opacity') * 100);
            setOpacityVal(props.selectedShapes[0].attr('fill-opacity') * 100 + '%');
        } else {
            if (props.selectedShape) {
                setOpacity(props.selectedShape.attr('fill-opacity') * 100);
                setOpacityVal(props.selectedShape.attr('fill-opacity') * 100 + '%');
            }
        }
    }, [props.selectedShape, props.selectedShapes])

    return (
        <section className='color-shape-menu-section' style={{ top: props.isStrokeColor ? '35px' : '50px' }} onClick={(e) => e.stopPropagation()}>
            <div className='color-menu_btns-block' style={{ marginBottom: props.isStrokeColor ? 0 : '16px' }}>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#000')}><span className='colorIcon black-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#fff')}><span className='colorIcon white-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#666')}><span className='colorIcon grey-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#ff0000')}><span className='colorIcon red-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#ffaa00')}><span className='colorIcon orange-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#ffff00')}><span className='colorIcon yellow-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#00ff00')}><span className='colorIcon green-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#0000ff')}><span className='colorIcon blue-color-btn'></span></button>
                <button className='color-menu-btn' onClick={() => handlerSetColor('#333')}><span className='colorIcon gradient-color-btn'></span></button>
            </div>
            {!props.isStrokeColor &&
                <div className='color-menu_range-block'>
                    <p className='color-menu_input-label'>Opacity</p>
                    <div className='color-menu_input-block'>
                        <input type='range' className='color-menu_range' onChange={handleShapeOpacityRange} min={0} max={100} step={1} value={opacity}></input>
                        <input type='text' id='colorInput' className='color-menu_input' value={opacityVal} disabled></input>
                    </div>
                </div>
            }
        </section>
    )
}